import React from 'react';
import Chart from 'react-apexcharts'
import Utils from '../../providers/Utils';


export default class ChartsSesiuni extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

            viewChart: true,
            series:

            [{name:'', data:this.props.sesiuni.map((s,idx)=>{
                return s.puncte
            })}]
                

            ,
            options: {
                chart: {
                    // height: 350,
                    width: '90%',
                    type: 'bar',
                    toolbar: {
                        show: false,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: false,
                            selection: true,

                        }
                    },


                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                        borderRadius: 8
                    }
                },
                legend: {
                    show: false
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val, idx,) {
                        console.log('idx :>> ', idx.w.config);
                        console.log('val :>> ', val);
                        return val

                    },
                    offsetY: -20,
                  
                    style: {
                        fontSize: '12px',
                        colors: ["black"]
                    }
                },
                labels: this.props.sesiuni.map((s,idx)=>{
                    return s.puncte
                }),

                xaxis: {
                    categories: this.props.sesiuni.map((s,idx)=>{
                        if(s.tip === 'evaluare_angajati'){
                            return 'Colegi'
                        }else if(s.tip === 'evaluare_sefi'){
                            return 'Manager'
                        }else{
                            return 'Clienti'
                        }
                    }),
                    labels: {
                        offsetX: 0,
                        offsetY: 0,
                    },
                    position: 'bottom',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        enabled: false,
                    },

                },
                yaxis: {
                    min: 0,
                    max:Math.floor(Math.max(...this.props.sesiuni.map(r => r.puncte)) +  Math.max(...this.props.sesiuni.map(r => r.puncte)) * 20 / 100) ,
                    axisBorder: {
                        show: true
                    },
                    axisTicks: {
                        show: true,
                    },
                    labels: {
                        show: true,
                        formatter: function (val) {
                            return val ;
                        }
                    }

                },
                title: {
                    text: 'Monthly Inflation in Argentina, 2002',
                    floating: true,
                    offsetY: - 50,
                    align: 'center',
                    style: {
                        color: '#444'
                    }
                }
            },

        }
    }

    u = new Utils()



    viewChart = true









    



    render() {
        return (


            <div style={{ background: 'white' }} id="chart">

               
                    <Chart
                        style={{ margin: 'auto' }}
                        options={this.state.options}
                        series={this.state.series}
                        type="bar"
                        width="90%"
                        height={400}
                    />
                

            </div>


        );
    }
}